import { render } from "./PolicyAcceptanceReport.vue?vue&type=template&id=1623cdd3&scoped=true"
import script from "./PolicyAcceptanceReport.vue?vue&type=script&lang=js"
export * from "./PolicyAcceptanceReport.vue?vue&type=script&lang=js"

import "./PolicyAcceptanceReport.vue?vue&type=style&index=0&id=1623cdd3&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1623cdd3"]])

export default __exports__